import React, { FC, memo, ComponentType, NamedExoticComponent } from "react";

import { Portal } from "../portal";
import { Overlay } from "../overlay";
import { OverflowHidden } from "../side-effects";

import styles from "./HalfCardHOC.scss";
import { withStyles } from "@core-ui/helpers/WithStyles";
import useFocusTrap from "@core-ui/hooks/UseFocusTrap";

export default function HalfCardHOC<T extends object>(PassedComponent: ComponentType<T>): NamedExoticComponent<T> {
    const HalfCardWrappedComponent: FC<T> = (props: T) => {
        useFocusTrap();
        return (
            <Portal>
                <OverflowHidden>
                    <>
                        <div className={styles.container}>
                            <PassedComponent {...props} />
                        </div>
                        <Overlay />
                    </>
                </OverflowHidden>
            </Portal>
        );
    };

    return memo(withStyles(HalfCardWrappedComponent, styles));
}
